import React, { ReactElement, ComponentPropsWithoutRef } from 'react';
import classnames from 'classnames';

export type SwitchProps = ComponentPropsWithoutRef<'input'> & {
  labelLeft?: string;
  labelRight?: string;
};

export function Switch({
  checked,
  id,
  labelLeft,
  labelRight,
  disabled = false,
  value,
  ...rest
}: SwitchProps): ReactElement {
  const classes = classnames('switch', {
    disabled,
  });

  return (
    <label className={classes} htmlFor={id}>
      <input
        checked={checked}
        type="checkbox"
        disabled={disabled}
        value={value}
        id={id}
        {...rest}
      />
      {labelLeft && <span className="switch__label">{labelLeft}</span>}
      <span className="switch__input" aria-checked={checked} />
      {labelRight && <span className="switch__label">{labelRight}</span>}
    </label>
  );
}
